"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var BUTTON_SIZE = 42;
var MIN_HEIGHT = 512;

var FilterTabContainer = function FilterTabContainer(_ref) {
  var _tabs$find, _currentTab$props$tit, _currentTab$props, _currentTab$props2;

  var className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      onClose = _ref.onClose,
      useOutsideClick = _ref.useOutsideClick,
      onReset = _ref.onReset,
      onTabChange = _ref.onTabChange,
      hideResetButton = _ref.hideResetButton;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showContainer = _useState4[0],
      setShowContainer = _useState4[1];

  var _useState5 = (0, _react.useState)(MIN_HEIGHT),
      _useState6 = _slicedToArray(_useState5, 2),
      containerHeight = _useState6[0],
      setContainerHeight = _useState6[1]; // start animation to min height until refs can be measured


  var ref = (0, _react.useRef)(null);
  var headerRef = (0, _react.useRef)(null);
  var tabsRef = (0, _react.useRef)(null);
  var resetButtonRef = (0, _react.useRef)(null);

  var changeTab = function changeTab(tabId) {
    setActiveTab(tabId);
    onTabChange(tabId);
  }; // trigger close if click outside of container is discovered


  (0, _hooks.useOnClickOutside)(ref, function () {
    if (useOutsideClick) {
      setShowContainer(false);
    }
  }); // calculate container height based on children and window height

  var _useWindowSize = (0, _hooks.useWindowSize)(),
      windowHeight = _useWindowSize.height;

  (0, _react.useEffect)(function () {
    if (!windowHeight || !ref.current || !headerRef.current || !tabsRef.current || !resetButtonRef.current) {
      return;
    }

    var _ref$current$getBound = ref.current.getBoundingClientRect(),
        top = _ref$current$getBound.top;

    var height = headerRef.current.getBoundingClientRect().height + tabsRef.current.getBoundingClientRect().height + resetButtonRef.current.getBoundingClientRect().height;
    var maxHeight = windowHeight - top - 32; // total height - top - margin bottom
    // clamp between min and max height

    setContainerHeight(Math.min(Math.max(height, MIN_HEIGHT), maxHeight));
  }, [windowHeight]);

  var tabs = _react["default"].Children.toArray(children);

  var currentTab = (_tabs$find = tabs.find(function (tab) {
    var _tab$props;

    return ((_tab$props = tab.props) === null || _tab$props === void 0 ? void 0 : _tab$props.id) === activeTab;
  })) !== null && _tabs$find !== void 0 ? _tabs$find : {};
  var currentTitle = (_currentTab$props$tit = currentTab === null || currentTab === void 0 ? void 0 : (_currentTab$props = currentTab.props) === null || _currentTab$props === void 0 ? void 0 : _currentTab$props.title) !== null && _currentTab$props$tit !== void 0 ? _currentTab$props$tit : intl.formatMessage({
    id: 'filters.title'
  });
  var currentContent = currentTab === null || currentTab === void 0 ? void 0 : (_currentTab$props2 = currentTab.props) === null || _currentTab$props2 === void 0 ? void 0 : _currentTab$props2.children;
  var containerStyle = (0, _reactSpring.useSpring)({
    from: {
      width: "".concat(BUTTON_SIZE, "px"),
      height: "".concat(BUTTON_SIZE, "px")
    },
    to: {
      width: '256px',
      height: "".concat(containerHeight, "px")
    },
    reverse: !showContainer,
    config: {
      duration: 200
    },
    onRest: function onRest() {
      if (!showContainer) {
        onClose();
      }
    }
  });
  var opacityStyle = (0, _reactSpring.useSpring)({
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    },
    reverse: !showContainer,
    config: {
      duration: 200
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
    style: _objectSpread(_objectSpread({}, style), containerStyle),
    ref: ref,
    role: "dialog",
    className: (0, _classnames["default"])('flex flex-col bg-white shadow-lg rounded box-content border overflow-hidden text-base text-primary', className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: headerRef,
    className: "flex justify-center font-bold p-2"
  }, activeTab === null ? /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "focus:outline-none z-1",
    title: intl.formatMessage({
      id: 'filters.closeDialog'
    }),
    onClick: function onClick() {
      return setShowContainer(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Funnel, null)) : /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "focus:outline-none z-1",
    title: intl.formatMessage({
      id: 'filters.back'
    }),
    onClick: function onClick() {
      return changeTab(null);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ChevronLeft, {
    className: "fill-primary"
  })), /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
    className: "mx-auto truncate",
    style: opacityStyle
  }, /*#__PURE__*/_react["default"].createElement("span", null, currentTitle))), activeTab === null ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
    className: "h-full overflow-auto",
    style: opacityStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: tabsRef
  }, tabs.map(function (child) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      onClick: function onClick() {
        var _child$props;

        changeTab((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.id);
      }
    });
  }))), !hideResetButton && /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
    ref: resetButtonRef,
    className: "p-2",
    style: opacityStyle
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    className: "w-full text-primary text-sm",
    onClick: onReset
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.reset"
  })))) : /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
    className: "h-full flex flex-col",
    style: opacityStyle
  }, /*#__PURE__*/_react["default"].cloneElement(currentContent)));
};

FilterTabContainer.defaultProps = {
  useOutsideClick: true,
  hideResetButton: false,
  className: '',
  style: {},
  children: null,
  onClose: function onClose() {},
  onReset: function onReset() {},
  onTabChange: function onTabChange() {}
};
var _default = FilterTabContainer;
exports["default"] = _default;